import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import queries from '../../../graphql/queries';

import ReadAnswers from './read-answers';
import WriteAnswers from './write-answers';
import TopWriters from './top-writers';
import RelatedTopics from './related-topics';

import style from './index.module.scss';

const {
  questionQueries: { QUESTIONS_BY_TOPIC },
} = queries;

function TopicMain({ topic }) {
  return (
    <div className={`col-12 ${style['topic-main']}`}>
      <div className={`row ${style['topic-main-content']}`}>
        <Query query={QUESTIONS_BY_TOPIC} variables={{ topicName: topic.name }}>
          {({ loading, error, data }) => {
            if (loading) return <div>Loading...</div>;
            if (error) return <div>Error!</div>;

            const { questionsByTopic } = data;

            return (
              <>
                {questionsByTopic.length > 0 ? (
                  <Switch>
                    <Route
                      path='/topic/:topicName'
                      exact
                      component={() => (
                        <ReadAnswers
                          topicName={topic.name}
                          questionList={questionsByTopic}
                        />
                      )}
                    />
                    <Route
                      path='/topic/:topicName/answer'
                      component={() => (
                        <WriteAnswers
                          topicName={topic.name}
                          questionList={questionsByTopic}
                        />
                      )}
                    />
                    <Route
                      path='/topic/:topicName/top-writers'
                      component={() => (
                        <TopWriters topWriters={topic.mostViewedWriters} />
                      )}
                    />
                    <Route
                      path='/topic/:topicName/related'
                      component={() => <RelatedTopics topicName={topic.name} />}
                    />
                  </Switch>
                ) : (
                  <p>Be the first one to contribute in {topic.name}</p>
                )}
              </>
            );
          }}
        </Query>
      </div>
    </div>
  );
}

TopicMain.propTypes = {
  topic: PropTypes.shape({
    name: PropTypes.string.isRequired,
    mostViewedWriters: PropTypes.array.isRequired,
  }).isRequired,
};

export default TopicMain;
